var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import render from 'utils/render';
const SvgSparkle = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const Element = render.element(/*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131 133",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.168,
    cy: 66.6112,
    rx: 4.22078,
    ry: 4.30519,
    fill: "url(#paint0_radial_7471_5109)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8819,
    cy: 1.77633,
    rx: 35.8819,
    ry: 1.77633,
    transform: "matrix(0.700071 -0.714073 0.700071 0.714073 38.8584 90.8639)",
    fill: "url(#paint1_radial_7471_5109)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.6909,
    cy: 1.77633,
    rx: 17.6909,
    ry: 1.77633,
    transform: "matrix(0.700072 0.714073 -0.700072 0.714073 54.0533 52.6912)",
    fill: "url(#paint2_radial_7471_5109)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7471_5109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.168 66.6112) rotate(90) scale(4.30519 4.22078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFC525",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFAD00",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6B02",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7471_5109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8819 1.77633) rotate(90) scale(1.77633 35.8819)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFC525",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFAD00",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6B02",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7471_5109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6909 1.77633) rotate(90) scale(1.77633 17.6909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFC525",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFAD00",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6B02",
    stopOpacity: 0
  }))))));
  return /*#__PURE__*/React.createElement(Element.type, _extends({}, Element.props, {
    ref: ref
  }), children, Element.props.children);
});
export default /*#__PURE__*/React.memo(SvgSparkle);